import Enum from 'enum'

export const userListOptions = new Enum({
  RANDOM: {
    display: 'Randomly Chosen'
  },
  CUSTOM: {
    display: 'Hand Picked'
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Online/HelpingTeamMemberSelection/Constants.js